<ng-container *ngIf="data">
  <div class="header">
    <span class="title"> {{ data.title }} </span>
    <button mat-icon-button tabindex="-1" class="close-button">
      <mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon>
    </button>
  </div>
  <mat-divider class="title-divider"></mat-divider>
  <div class="status-container">
    <div *ngIf="isLoading" class="loader">
      <mat-spinner class="progress-spinner"></mat-spinner>
      <div class="loader-message">{{ loaderMessage }}</div>
    </div>
    <div *ngIf="!isLoading">
      <div>
        <i class="material-icons icon" [ngClass]="icon" *ngIf="icon"></i>
      </div>
      <mat-dialog-content [innerHTML]="message"> </mat-dialog-content>
      <div mat-dialog-actions class="actions">
        <button mat-flat-button (click)="onButtonClick()">{{ okText }}</button>
        <button mat-button mat-dialog-close class="cancel-button">{{ cancelText }}</button>
      </div>
    </div>
  </div>
</ng-container>
